<div class="container">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <div class="titleIcon">
        <mat-icon class="Icon">view_list</mat-icon>

        Reset Partner Password
      </div>
    </h1>
  </section>
  <section mat-dialog-content>
    <h3>
      Are you sure you want to email <span class="email">{{email}}</span> a
      password reset?
    </h3>
  </section>
  <section align="end" mat-dialog-actions>
    <button
      mat-button
      mat-dialog-close
      matTooltip="Cancel and close."
      type="button"
    >
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>
    <button
      [disabled]="loading"
      mat-button
      matTooltip="Reset partner password."
      type="button"
      (click)="onSubmit()"
    >
      <mat-icon>save</mat-icon>
      Send
    </button>
  </section>
</div>
